import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { FullScreenLoader } from "./FullScreenLoader";

const RedirectWithReferral = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [cookies, setCookie, removeCookie] = useCookies([
        "refBrandAddress",
        "preferredLanguage",
    ]);
    const [readyToRedirect, setReadyToRedirect] = useState(false);

    useEffect(() => {
        const HARDCODED_UA_REFERRALS = ["eacademy"];
        const params = new URLSearchParams(location.search);
        const refBrandAddress = params.get("ref");

        if (refBrandAddress) {
            setCookie("refBrandAddress", refBrandAddress, {
                path: "/",
                maxAge: 60 * 60 * 24 * 7, // 7 days
            });
        }

        if (cookies.preferredLanguage === "uk") setReadyToRedirect(true);

        // Force UA for specific referrals
        if (
            refBrandAddress &&
            HARDCODED_UA_REFERRALS.includes(refBrandAddress)
        ) {
            setCookie("preferredLanguage", "uk", {
                path: "/",
                maxAge: 60 * 60 * 24 * 365,
                sameSite: "lax",
            });
            console.log("Setting UK lang cookie");
        } else {
            setReadyToRedirect(true);
        }
    }, [location.search, setCookie, removeCookie, cookies.preferredLanguage]);

    useEffect(() => {
        if (readyToRedirect) navigate("/creation", { replace: true });
    });

    return <FullScreenLoader />; // or a loading spinner
};

export default RedirectWithReferral;
